import { IPromise, IHttpService, IRequestShortcutConfig } from "angular";

import { IGetReactionParams, IAggregatedReaction, ICreateReaction, IReaction } from "../models/models";
import { ICollection } from "@gtmhub/models";
import { IReactionAnnouncements } from "@gtmhub/announcements/models/reactions";
import { EnvironmentService } from "@gtmhub/env";
import { getCurrentUserId } from "@gtmhub/users";
import { IFeedEntryReaction } from "@gtmhub/feed/models";

export class ReactionService {
  public static $inject = ["$http", "EnvironmentService"];

  private shouldPreventDblClick = false;

  getPreventDblClick(): boolean {
    return this.shouldPreventDblClick;
  }

  setPreventDblClick(prevent: boolean) {
    this.shouldPreventDblClick = prevent;
  }

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public getReactions(getReactionParams: IGetReactionParams = null): IPromise<ICollection<IAggregatedReaction>> {
    const url = this.env.getApiEndpoint("/reactions");
    const query: IRequestShortcutConfig = {
      params: getReactionParams,
    };

    return this.$http.get<ICollection<IAggregatedReaction>>(url, query).then((response) => response.data);
  }

  public createReaction(createReaction: ICreateReaction, isReactionOnGif = false): IPromise<IReaction> {
    const url = this.env.getApiEndpoint("/reactions");

    const gtmhubAdditionalParams: IRequestShortcutConfig = {
      params: {
        gtmhubAdditionalParams: {
          reactionOnGif: isReactionOnGif,
        },
      },
    };

    return this.$http.post<IReaction>(url, createReaction, gtmhubAdditionalParams).then((response) => response.data);
  }

  public deleteReaction(reactionName: string, targetId: string): IPromise<void> {
    const url = this.env.getApiEndpoint(`/reactions/${reactionName}/${targetId}`);

    return this.$http.delete<void>(url).then((response) => response.data);
  }

  public onReactionCreated(reactions: IAggregatedReaction[] | IFeedEntryReaction[], newReaction: IReaction): IAggregatedReaction[] | IFeedEntryReaction[] {
    const reactionsArray = reactions ? [...reactions] : [];
    const foundReaction = reactionsArray.find((reaction) => reaction.name === newReaction.name);

    if (foundReaction) {
      foundReaction.currentUserReacted = true;
      foundReaction.userIds.push(newReaction.userId);
    } else {
      const { userId, name, emoji } = { ...newReaction };

      const reactionToPush: IFeedEntryReaction | IAggregatedReaction = {
        name,
        emoji,
        userIds: [userId],
        currentUserReacted: true,
      };

      reactionsArray.push(reactionToPush);
    }

    return reactionsArray;
  }

  public onReactionDeleted<TypeReaction extends IAggregatedReaction | IFeedEntryReaction>(
    reactions: TypeReaction[],
    deletedReaction: IAggregatedReaction
  ): TypeReaction[] {
    let reactionsArray = reactions ? [...reactions] : [];
    const foundReaction = reactionsArray.find((reaction) => reaction.name === deletedReaction.name);

    if (foundReaction) {
      foundReaction.currentUserReacted = false;
      foundReaction.userIds = foundReaction.userIds.filter((userId) => userId !== getCurrentUserId());

      if (!foundReaction.userIds.length) {
        reactionsArray = reactionsArray.filter((currentReaction) => currentReaction.name !== deletedReaction.name);
      }
    }

    return reactionsArray;
  }

  public get(): IPromise<ICollection<IReactionAnnouncements>> {
    const url = this.env.getApiEndpoint("/reactions");

    return this.$http.get<ICollection<IReactionAnnouncements>>(url).then((response) => {
      // this is a temporary fix until the backend is ready
      // the filter i applied only for the clap emmoji in announcements
      response.data.items = response.data.items.filter((item) => item.id === "5b10f67270210e0007573541");
      return response.data;
    });
  }
}
